"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormGroup = _interopRequireDefault(require("../FormGroup"));

var _FormControlMessage = _interopRequireDefault(require("../FormControlMessage"));

var _TextInputIcon = _interopRequireDefault(require("./TextInputIcon"));

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

var _Label = _interopRequireDefault(require("../Label"));

var _Icon = _interopRequireWildcard(require("../Icon"));

var _utils = require("../../utils");

var _uid = _interopRequireDefault(require("../../utils/uid"));

var _CoreInput = _interopRequireDefault(require("./CoreInput"));

require("./TextInput.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** A basic widget for getting the user input is a text field.
 * Keyboard and mouse can be used for providing or changing data.
 *
 * DO Always use labels on text inputs and don’t depend on the placeholder
 * text. If there is more information for the text input needed make
 * use of a paragraph on top or use an info box. */
var TextInput = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var disabled = props.disabled,
      error = props.error,
      errorIcon = props.errorIcon,
      errorInTooltip = props.errorInTooltip,
      label = props.label,
      isError = props.isError,
      labelInfobox = props.labelInfobox,
      helpText = props.helpText,
      required = props.required,
      questionmark = props.questionmark,
      verified = props.verified,
      search = props.search,
      children = props.children,
      onChange = props.onChange,
      onKeyUp = props.onKeyUp,
      onFocus = props.onFocus,
      searchDelay = props.searchDelay,
      searchCharsNumber = props.searchCharsNumber,
      prefix = props.prefix,
      id = props.id,
      className = props.className,
      rest = _objectWithoutProperties(props, ["disabled", "error", "errorIcon", "errorInTooltip", "label", "isError", "labelInfobox", "helpText", "required", "questionmark", "verified", "search", "children", "onChange", "onKeyUp", "onFocus", "searchDelay", "searchCharsNumber", "prefix", "id", "className"]);

  var iconProps = {
    errorInTooltip: errorInTooltip,
    error: error,
    errorIcon: errorIcon,
    questionmark: questionmark,
    verified: verified
  };
  var hasSuffix = (0, _react.useMemo)(function () {
    return error || questionmark || verified;
  }, [error, questionmark, verified]);
  var prefixProp = (0, _react.useMemo)(function () {
    return search || prefix ? {
      prefix: search ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
        type: _Icon.ICON_TYPE_SEARCH,
        className: "search-icon"
      }) : prefix
    } : {};
  }, [search, prefix]);
  var searchTimer;

  var onSearch = function onSearch(e) {
    var value = e.target.value;
    clearTimeout(searchTimer);

    if (value.length === 0 || value.length >= searchCharsNumber) {
      searchTimer = setTimeout(function () {
        return onChange(value);
      }, searchDelay);
    } else {
      e.preventDefault();
    }
  };

  var classNames = (0, _utils.getClassNames)({
    TextInput_invalid: error || isError
  }, {
    'TextInput_with-search': search
  }, className);
  var inputId = id || (0, _uid.default)('text-input');
  return /*#__PURE__*/_react.default.createElement(_FormGroup.default, {
    disabled: disabled,
    error: error
  }, label && /*#__PURE__*/_react.default.createElement(_Label.default, {
    htmlFor: inputId,
    label: label,
    helpText: helpText,
    labelInfobox: labelInfobox,
    required: required
  }), /*#__PURE__*/_react.default.createElement(_CoreInput.default, _extends({}, rest, prefixProp, {
    id: inputId,
    className: classNames,
    suffix: hasSuffix && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
      title: errorInTooltip ? error : null
    }, /*#__PURE__*/_react.default.createElement(_TextInputIcon.default, iconProps)),
    disabled: disabled,
    required: required,
    onChange: search ? onSearch : onChange,
    onKeyUp: onKeyUp,
    onFocus: onFocus,
    ref: ref,
    search: search
  })), error && !errorInTooltip && /*#__PURE__*/_react.default.createElement(_FormControlMessage.default, null, error), children && /*#__PURE__*/_react.default.createElement("p", null, children));
});
TextInput.propTypes = {
  /** The label text */
  label: _propTypes.default.string,

  /** The text to be displayed in the label tooltip */
  helpText: _propTypes.default.string,

  /** The text displayed if the label tooltip exist */
  labelInfobox: _propTypes.default.bool,

  /** The placeholder text */
  placeholder: _propTypes.default.string,

  /** @ignore */
  defaultValue: _propTypes.default.string,

  /** @ignore */
  disabled: _propTypes.default.bool,

  /** If required field* */
  required: _propTypes.default.bool,

  /** The error box displayed if true */
  isError: _propTypes.default.bool,

  /** The error message displayed if the input is errored */
  error: _propTypes.default.string,

  /** If the space does not allow show error message below the input
   *  make use of the red error indicator with tooltip. */
  errorIcon: _propTypes.default.bool,

  /** The error message displayed is tooltip */
  errorInTooltip: _propTypes.default.bool,

  /** Whether the input field has questionmark icon */
  questionmark: _propTypes.default.bool,

  /** Whether the input field has verified icon */
  verified: _propTypes.default.bool,

  /** Change action for the input field */
  onChange: _propTypes.default.func,

  /** Keyup action for the input field */
  onKeyUp: _propTypes.default.func,

  /** Focus action for the input field */
  onFocus: _propTypes.default.func,

  /** Whether the input is search field */
  search: _propTypes.default.bool,

  /** The delay before search field will change */
  searchDelay: _propTypes.default.number,

  /** The number of characters before search field will change */
  searchCharsNumber: _propTypes.default.number,

  /** The prefix icon for the input. */
  prefix: _propTypes.default.node,

  /** @ignore */
  addonAfter: _propTypes.default.string,

  /** @ignore */
  id: _propTypes.default.string,

  /** @ignore */
  className: _propTypes.default.string,

  /** @ignore */
  children: _propTypes.default.node
  /** @ignore */

};
TextInput.defaultProps = {
  label: null,
  helpText: null,
  labelInfobox: false,
  placeholder: null,
  defaultValue: null,
  disabled: false,
  required: false,
  error: null,
  isError: false,
  errorIcon: false,
  errorInTooltip: false,
  questionmark: false,
  verified: false,
  onChange: function onChange() {},
  onKeyUp: function onKeyUp() {},
  onFocus: function onFocus() {},
  search: false,
  searchDelay: 300,
  searchCharsNumber: 3,
  prefix: null,
  id: null,
  className: '',
  addonAfter: null,
  children: null
};
var _default = TextInput;
exports.default = _default;